import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { toastWarning } from '../../../utilities/toast';
//import { getBaseURL} from '../../../utilities/config';

const aroBaseQuery = async (args, api, extraOptions) => {
    const rawBaseQuery = fetchBaseQuery({
    //baseUrl: getBaseURL(),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.token;
            headers.set('Authorization', token.jwtToken);
            headers.set('Accept', 'application/json');
            return headers;
        },
        timeout: 25000,
    });
    const skipRetry =
    typeof args === 'object' && 'meta' in args && args.meta?.skipRetry;

    let result = await rawBaseQuery(args, api, extraOptions);

    if (result.error && !skipRetry) {
        console.log('===== > Slice retry for', args);
        toastWarning('Trying again. Things are a little slow right now...');
        // ✅ Retry after 5 seconds (simple retry once)
        await new Promise((res) => setTimeout(res, 5000));
        result = await rawBaseQuery(args, api, extraOptions);
    }

    return result;
};

export const aroApiSlice = createApi({
    reducerPath: 'aroApi',
    baseQuery: aroBaseQuery,
    tagTypes: ['Kanban', 'ScoutProperty', 'ScoutProject', 'Acquisitions'],
    // endpoints injected in specific api slices
    endpoints: () => ({}),
});
